// src/composables/reports/useVentasMetodoPagoQuery.ts
import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';
import { getVentasPorMetodoPagoAction } from '../actions';

export function useVentasMetodoPagoQuery(
  fechaInicio?: Ref<string>,
  fechaFin?: Ref<string>
) {
  const query= useQuery({
    queryKey: computed(() => [
      'ventas-metodo-pago',
      fechaInicio?.value ?? '',
      fechaFin?.value ?? '',
    ]),
    queryFn: async () => {
      const response = await getVentasPorMetodoPagoAction(
        fechaInicio?.value,
        fechaFin?.value
      );
      return response.data;
    },
    staleTime: 60000,
    placeholderData: (previousData) => previousData
  });
  const ventasMetodoPagoData = computed(() => query.data.value);
  return {
    ventasMetodoPagoData,
   ...query,
  };

}